import { isMapStyleReady } from '../mapcore.js';
// Layer "rischi" v2 — port fedele dei layer v1 (map-layers.js + map-water-resources.js):
//  - alerts          allerte meteo-idro DPC (poligoni zone, oggi/domani)     ~v1:3121-3210
//  - wildfireAlerts  allerte incendi DRPC (poligoni province)                ~v1:2761-2837
//  - firms           hotspot incendi satellitari (NASA FIRMS via API)        ~v1:2121-2175
//  - etna            stato Etna (VONA + VAAC + MIROVA)                       ~v1:685-735
//  - waterResources  invasi/risorse idriche (solo marker+popup)              map-water-resources.js
//  - rivers          portata fiumi GloFAS (Open-Meteo Flood)                 ~v1:1070-1098
//  - bathing         balneazione EEA + stato mare Open-Meteo Marine          ~v1:977-1068
//
// Rendering MapLibre (pattern storms.js/stations.js/derived-points.js):
//  - poligoni → source GeoJSON + fill layer + line layer (livello criticità
//    pre-calcolato in properties, colori/opacità/spessori IDENTICI alla v1;
//    il tratteggio del livello 0 è un line layer separato, dasharray in unità
//    di line-width come in storms.js);
//  - badge divIcon v1 → sprite canvas (map.addImage con pixelRatio) + symbol
//    layer, resa replicata dal CSS v1 (map.css) + html inline del divIcon;
//  - popup click = bindPopup v1 (markup ESATTO), hover = bindTooltip v1;
//  - guard isStyleLoaded con retry su once('idle'); refresh con guard
//    document.hidden (firms 15', wildfireAlerts 30').
//
// Auth: la v1 chiama TUTTI questi endpoint api.weathersicily.it con fetch
// semplice SENZA token (map-layers.js/map-water-resources.js non passano da
// WSWeatherApi.get) → si replica il fetch nudo. WSWeatherApi resta per gli
// endpoint che richiedono il Bearer (es. /stations).

const API_BASE = (window.WEATHERSICILY_API_BASE || 'https://api.weathersicily.it/v1').replace(/\/+$/, '');
const WEATHER_ALERTS_API = window.WEATHERSICILY_WEATHER_ALERTS_API || `${API_BASE}/alerts/weather`;
const FIRMS_API_URL = window.WEATHERSICILY_FIRES_API || `${API_BASE}/fires/detections`;
const WILDFIRE_ALERTS_API_URLS = Array.from(new Set([
    window.WEATHERSICILY_WILDFIRE_ALERTS_API,
    `${API_BASE}/fires/wildfire-alerts?format=geojson`
].filter(Boolean)));
const RESERVOIRS_API = 'https://api.weathersicily.it/v1/reservoirs';

// (2026-07-03: heatWave rimosso come in v1)

// La v1 usa path relativi 'assets/data/...' dalla root del sito; la v2 vive
// in /v2/ quindi i path vanno ancorati alla root (pattern derived-points.js).
const MUNICIPALITIES_GEOJSON_URL = window.WEATHERSICILY_MUNICIPALITIES_GEOJSON_URL || '/assets/data/sicily-municipalities.geojson';
const ETNA_STATUS_URL = '/assets/data/etna-status.json';
const ETNA_PLUME_URL = '/assets/data/etna-ash-plume.geojson';
const ETNA_TREMOR_SERIES_URL = '/assets/data/etna-tremor-series.json';
let etnaTremorSeries = null;  // { series:[[t,v]...], baseline }
let etnaPlumeMeta = null;     // { mode, steps, now_ti } del pennacchio concentrazione
let etnaTi = 0, etnaSteps = [], etnaSlider = null, etnaAnim = null;  // slider temporale del pennacchio
let etnaUserMoved = false;  // l'utente ha scelto uno step → l'auto-refresh non lo resetta

function stopEtnaAnim() {
    if (etnaAnim) { clearInterval(etnaAnim); etnaAnim = null; }
    if (etnaSlider) etnaSlider.querySelector('.wsv2-nt-play').textContent = '▶';
}

function removeEtnaSlider() {
    stopEtnaAnim();
    if (etnaSlider) { etnaSlider.remove(); etnaSlider = null; }
    etnaSteps = [];
    etnaUserMoved = false;
}

function setEtnaTime(idx) {
    etnaTi = idx;
    const map = state.map;
    const filt = ['==', ['get', 'ti'], idx];
    for (const suf of ['-fill', '-line']) {
        const lid = srcId('etnaPlume') + suf;
        if (map.getLayer(lid)) map.setFilter(lid, filt);
    }
    if (etnaSlider) {
        const s = etnaSteps[idx] || {};
        // Tag relativo all'OROLOGIO REALE (non all'indice): lo step copre [valid, valid+3h).
        // Prima mostrava "+3h" contando dal primo step → sembrava una timeline live
        // bloccata su una previsione (bug segnalato dall'utente).
        let tag = '';
        if (s.valid) {
            const v = new Date(s.valid.replace(' ', 'T'));
            const dh = (v.getTime() - Date.now()) / 3600000;
            if (dh <= 0 && dh > -3) tag = '<b class="now">in corso</b>';
            else if (dh > 0) tag = `<b class="future">tra ${Math.round(dh)}h</b>`;
            else tag = `<b class="past">${Math.round(-dh)}h fa</b>`;
        }
        etnaSlider.querySelector('.wsv2-nt-label').innerHTML = `${tag} ${s.label || ''}`;
        const range = etnaSlider.querySelector('input[type=range]');
        range.value = String(idx);
        const pct = etnaSteps.length > 1 ? (idx / (etnaSteps.length - 1)) * 100 : 0;
        range.style.setProperty('--now-pct', `${pct.toFixed(1)}%`);
    }
}

// Slider dispersione cenere: STESSO stile/markup della timeline principale
// (wsv2-panel wsv2-nt): edge + play + range + label + torna-ad-adesso.
function ensureEtnaSlider(steps, nowTi) {
    if (!steps || steps.length < 2) { removeEtnaSlider(); return; }
    etnaSteps = steps;
    // default = step IN CORSO (valid <= adesso < valid+3h), non il "più vicino"
    // (che può essere un'ora futura e confondere). Fallback: now_ti del server.
    // Se l'utente ha scelto uno step, l'auto-refresh (5') NON lo resetta.
    if (etnaUserMoved && etnaTi < steps.length) {
        setEtnaTime(etnaTi);  // riallinea label/filtri sui dati freschi
    } else {
        let cur = null;
        for (let i = 0; i < steps.length; i++) {
            if (!steps[i].valid) continue;
            const dh = (new Date(steps[i].valid.replace(' ', 'T')).getTime() - Date.now()) / 3600000;
            if (dh <= 0 && dh > -3) { cur = i; break; }
        }
        etnaTi = cur != null ? cur : ((nowTi != null && nowTi < steps.length) ? nowTi : 0);
    }
    if (!etnaSlider) {
        const el = document.createElement('div');
        el.className = 'wsv2-panel wsv2-nt wsv2-nt--etna';
        el.innerHTML = '<span class="wsv2-nt-edge"><b>🌫️</b><small>cenere</small></span>'
            + '<button class="wsv2-nt-play" title="Anima la dispersione">▶</button>'
            + '<input type="range" min="0" value="0" step="1" aria-label="Ora della previsione cenere">'
            + '<span class="wsv2-nt-label"></span>'
            + '<button class="wsv2-nt-live" title="Torna ad adesso">●</button>'
            + '<span class="wsv2-nt-edge"><b class="ws-etna-span"></b><small>previsione</small></span>';
        document.body.appendChild(el);
        const range = el.querySelector('input[type=range]');
        range.addEventListener('input', () => { stopEtnaAnim(); etnaUserMoved = true; setEtnaTime(parseInt(range.value, 10)); });
        el.querySelector('.wsv2-nt-live').addEventListener('click', () => {
            stopEtnaAnim();
            // stesso criterio del default: step IN CORSO rispetto all'orologio reale
            let cur = 0;
            for (let i = 0; i < etnaSteps.length; i++) {
                if (!etnaSteps[i].valid) continue;
                const dh = (new Date(etnaSteps[i].valid.replace(' ', 'T')).getTime() - Date.now()) / 3600000;
                if (dh <= 0 && dh > -3) { cur = i; break; }
            }
            setEtnaTime(cur);
        });
        el.querySelector('.wsv2-nt-play').addEventListener('click', (e) => {
            if (etnaAnim) { stopEtnaAnim(); return; }
            e.target.textContent = '⏸';
            etnaAnim = setInterval(() => {
                setEtnaTime((etnaTi + 1) % etnaSteps.length);
            }, 900);
        });
        etnaSlider = el;
    }
    const range = etnaSlider.querySelector('input[type=range]');
    range.max = String(steps.length - 1);
    const hours = steps.map(step => Number(step && step.hour)).filter(Number.isFinite);
    const horizon = hours.length ? Math.max(...hours) : (steps.length - 1) * 3;
    etnaSlider.querySelector('.ws-etna-span').textContent = '+' + horizon + 'h';
    setEtnaTime(etnaTi);
}
// Flight Level (centinaia di piedi) → quota in km, per un testo comprensibile.
function flToKm(fl) {
    if (!fl) return null;
    return (Math.round(fl * 100 * 0.3048 / 100) / 10).toString().replace('.', ',');
}
const RIVERS_URL = '/assets/data/rivers.json';
const BATHING_URL = '/assets/data/bathing-water.json';

const FIRMS_REFRESH_MS = 15 * 60 * 1000;      // v1: 15'
const WILDFIRE_REFRESH_MS = 30 * 60 * 1000;   // v1: 30'

const EMPTY = { type: 'FeatureCollection', features: [] };

export const RISK_KEYS = ['alerts', 'wildfireAlerts', 'firms', 'etna', 'waterResources', 'rivers', 'bathing'];

// ---------------------------------------------------------------------------
// helper generici
// ---------------------------------------------------------------------------

function wsLayerEsc(value) {
    return String(value ?? '').replace(/[&<>"']/g, char => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[char]));
}

// Data odierna in fuso Europe/Rome come YYYY-MM-DD (port di wsRomeDateISO).
function wsRomeDateISO() {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(new Date());
}

// it-IT a cifre fisse (port di formatNumber, map-water-resources.js).
function formatNumber(value, digits = 1) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '--';
    return new Intl.NumberFormat('it-IT', {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits
    }).format(number);
}

function emitStatus(html) {
    document.dispatchEvent(new CustomEvent('wsv2:risk-status', { detail: { html } }));
}

// ---------------------------------------------------------------------------
// stato modulo
// ---------------------------------------------------------------------------

const state = {
    map: null,
    beforeId: undefined,
    enabled: {},
    seq: {},          // anti-race per fetch in volo (pattern derived-points.js)
    wired: {},
    pendingIdle: {},
    timers: {},
    alertsDay: 'today',   // setAlertsDay('today'|'tomorrow')
    alertsData: null,     // {geojson, alertsToday, alertsTomorrow}
    bathingSeason: '',
};
RISK_KEYS.forEach(k => { state.enabled[k] = false; state.seq[k] = 0; });

function srcId(key) { return 'ws-risk-' + key; }

// Style non ancora pronto (primo load): riprova quando la mappa è idle
// (pattern storms.js/derived-points.js).
function styleReady(key, retry) {
    const map = state.map;
    if (isMapStyleReady(map)) return true;
    if (!state.pendingIdle[key]) {
        state.pendingIdle[key] = true;
        map.once('idle', () => {
            state.pendingIdle[key] = false;
            if (state.enabled[key]) retry();
        });
    }
    return false;
}

function beforeStations() {
    const map = state.map;
    return map.getLayer('ws-stations-symbols') ? 'ws-stations-symbols' : state.beforeId;
}

function setData(key, features) {
    const src = state.map && state.map.getSource(srcId(key));
    if (src) src.setData({ type: 'FeatureCollection', features });
}

// ---------------------------------------------------------------------------
// sprite canvas — replica dei badge divIcon v1 (CSS map.css + html inline)
// ---------------------------------------------------------------------------

function spriteDpr() {
    return Math.max(1, Math.min(window.devicePixelRatio || 1, 2.5));
}

// Badge circolare: cerchio pieno + anello + ombra + contenuto (emoji/testo).
// ringPos 'inside' = border CSS con box-sizing:border-box (heatwave, water);
// ringPos 'outside' = box-shadow 0 0 0 Npx #fff (etna, rivers).
function circleBadgeSprite({ size, fill, ringColor = '#ffffff', ringWidth = 2, ringPos = 'outside', shadow = null, content = null }) {
    const dpr = spriteDpr();
    const pad = Math.ceil((ringPos === 'outside' ? ringWidth : 0) + (shadow ? shadow.blur + Math.abs(shadow.dy || 0) : 0) + 2);
    const w = size + pad * 2;
    const canvas = document.createElement('canvas');
    canvas.width = Math.ceil(w * dpr);
    canvas.height = Math.ceil(w * dpr);
    const ctx = canvas.getContext('2d', { alpha: true });
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const c = w / 2;
    const r = size / 2;
    if (shadow) {
        ctx.save();
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur;
        ctx.shadowOffsetY = (shadow.dy || 0);
        ctx.beginPath();
        ctx.arc(c, c, r, 0, Math.PI * 2);
        ctx.fillStyle = fill;
        ctx.fill();
        ctx.restore();
    }
    ctx.beginPath();
    ctx.arc(c, c, r, 0, Math.PI * 2);
    ctx.fillStyle = fill;
    ctx.fill();
    if (ringWidth > 0) {
        ctx.lineWidth = ringWidth;
        ctx.strokeStyle = ringColor;
        ctx.beginPath();
        ctx.arc(c, c, ringPos === 'outside' ? r + ringWidth / 2 : r - ringWidth / 2, 0, Math.PI * 2);
        ctx.stroke();
    }
    if (content) content(ctx, c, c);
    return { canvas, dpr };
}

function ensureImage(key, builder) {
    const map = state.map;
    if (map.hasImage(key)) return;
    const sprite = builder();
    const ctx = sprite.canvas.getContext('2d');
    map.addImage(key, ctx.getImageData(0, 0, sprite.canvas.width, sprite.canvas.height), { pixelRatio: sprite.dpr });
}

// ---------------------------------------------------------------------------
// popup / tooltip condivisi (pattern derived-points.js): le properties dei
// feature portano pp (popup click pre-renderizzato), tt (tooltip hover), mw.
// ---------------------------------------------------------------------------

let hoverPopup = null;
let clickPopup = null;

function ensureHoverPopup() {
    if (!hoverPopup) {
        hoverPopup = new maplibregl.Popup({
            closeButton: false, closeOnClick: false, offset: 10,
            className: 'wsv2-tooltip-shell ws-derived-tooltip-shell', maxWidth: '280px',
        });
    }
    return hoverPopup;
}

function openClickPopup(lngLat, html, maxWidth, shellClass) {
    if (hoverPopup) hoverPopup.remove();
    if (clickPopup) clickPopup.remove();
    clickPopup = new maplibregl.Popup({
        closeButton: true, closeOnClick: true, offset: 12,
        className: 'wsv2-tooltip-shell ' + (shellClass || ''),
        maxWidth: (maxWidth || 280) + 'px',
    }).setLngLat(lngLat).setHTML(html).addTo(state.map);
    // I click DENTRO il popup (es. link "Bollettino VAAC") non devono risalire
    // alla mappa: con closeOnClick il popup si chiuderebbe annullando il link.
    const el = clickPopup.getElement();
    if (el) el.addEventListener('click', (ev) => ev.stopPropagation());
}

// Punti/badge: popup sul punto stesso; poligoni: popup dove si clicca (come
// il bindPopup Leaflet sui poligoni).
function wireInteractions(key, layerId, { atClick = false, shellClass = '' } = {}) {
    const wiredKey = key + '|' + layerId;
    if (state.wired[wiredKey]) return;
    state.wired[wiredKey] = true;
    const map = state.map;
    map.on('mousemove', layerId, (e) => {
        const f = e.features && e.features[0];
        if (!f) return;
        map.getCanvas().style.cursor = 'pointer';
        if (f.properties.tt) {
            ensureHoverPopup()
                .setLngLat(atClick ? e.lngLat : f.geometry.coordinates)
                .setHTML(`<div class="ws-derived-tooltip">${f.properties.tt}</div>`)
                .addTo(map);
        }
    });
    map.on('mouseleave', layerId, () => {
        map.getCanvas().style.cursor = '';
        if (hoverPopup) hoverPopup.remove();
    });
    map.on('click', layerId, (e) => {
        const f = e.features && e.features[0];
        if (!f || !f.properties.pp) return;
        openClickPopup(atClick ? e.lngLat : f.geometry.coordinates, f.properties.pp, f.properties.mw, shellClass);
    });
}

// ---------------------------------------------------------------------------
// ALERTS — allerte meteo-idro DPC (poligoni zone SICI-*)
// Unica autorità: API Weather Sicily, con bollettino e geometrie locali.
// ---------------------------------------------------------------------------

function alertLevel(item) {
    if (!item) return 0;
    return Math.max(0, Math.min(3, Number(item.level) || 0));
}

function alertText(level) {
    return ['Nessuna allerta', 'Allerta gialla', 'Allerta arancione', 'Allerta rossa'][level] || 'Nessuna allerta';
}

function alertShortText(level) {
    return ['Verde', 'Gialla', 'Arancione', 'Rossa'][level] || 'Verde';
}

function alertPalette(level) {
    if (level === 3) return { stroke: '#7f1d1d', fill: '#ff0000', soft: '#fee2e2', text: '#7f1d1d' };
    if (level === 2) return { stroke: '#9a3412', fill: '#ff6a00', soft: '#ffedd5', text: '#7c2d12' };
    if (level === 1) return { stroke: '#854d0e', fill: '#ffe100', soft: '#fef9c3', text: '#713f12' };
    return { stroke: '#166534', fill: '#00b341', soft: '#dcfce7', text: '#14532d' };
}

async function fetchWeatherAlertsApiGeojson(day) {
    const response = await fetch(`${WEATHER_ALERTS_API}?day=${encodeURIComponent(day)}&format=geojson`, { cache: 'no-store' });
    if (!response.ok) throw new Error('WEATHER_ALERTS_API_ERROR');
    const payload = await response.json();
    const features = payload?.features;
    if (payload?.type !== 'FeatureCollection' || !Array.isArray(features) || !features.length
        || features.some(feature => !feature?.geometry)) {
        throw new Error('WEATHER_ALERTS_API_PAYLOAD');
    }
    return payload;
}

function apiAlertByZone(geojson) {
    const byZone = new Map();
    (geojson?.features || []).forEach(feature => {
        const props = feature?.properties || {};
        const code = props.zone_code || props.zona_codice;
        if (!code) return;
        byZone.set(code, {
            zona_codice: code,
            zona_nome: props.zone_name || props.zona_nome || code,
            level: Number(props.level || 0),
            updated_at: props.updated_at,
            levels: props.levels || {}
        });
    });
    return byZone;
}

// Popup zona (port ESATTO di alertPopupMarkup, v1:3093-3119).
function alertPopupMarkup(name, code, todayLevel, tomorrowLevel, validity, tomorrowValidity) {
    const level = Math.max(todayLevel, tomorrowLevel);
    const palette = alertPalette(level);
    const todayPalette = alertPalette(todayLevel);
    const tomorrowPalette = alertPalette(tomorrowLevel);
    const summary = todayLevel === tomorrowLevel
        ? `${alertText(level)} su oggi e domani.`
        : `Oggi ${alertShortText(todayLevel).toLowerCase()}, domani ${alertShortText(tomorrowLevel).toLowerCase()}.`;

    const row = (label, rowLevel, rowPalette, rowValidity) => `<div class="ws-alert-popup__row" style="--alert-row-fill:${rowPalette.fill};--alert-row-fg:${rowPalette.text};--alert-row-line:${rowPalette.stroke};">
        <span>${wsLayerEsc(label)}</span>
        <strong>${wsLayerEsc(alertText(rowLevel))}</strong>
        ${rowValidity ? `<small>${wsLayerEsc(rowValidity)}</small>` : ''}
    </div>`;

    return `<article class="ws-alert-popup" style="--alert-fill:${palette.fill};--alert-fg:${palette.text};--alert-line:${palette.stroke};--alert-soft:${palette.soft};">
        <header>
            <span>${wsLayerEsc(code)}</span>
            <strong>${wsLayerEsc(name)}</strong>
        </header>
        <p>${wsLayerEsc(summary)}</p>
        <div class="ws-alert-popup__rows">
            ${row('Oggi', todayLevel, todayPalette, validity)}
            ${row('Domani', tomorrowLevel, tomorrowPalette, tomorrowValidity)}
        </div>
    </article>`;
}

function ensureAlertsLayers() {
    const map = state.map;
    if (map.getSource(srcId('alerts'))) return true;
    if (!styleReady('alerts', () => { renderAlerts(); })) return false;
    map.addSource(srcId('alerts'), { type: 'geojson', data: EMPTY });
    const before = beforeStations();  // v1: alertsPane z470, SOTTO i marker stazione
    const fills = ['match', ['get', 'lvl'], 3, '#ff0000', 2, '#ff6a00', 1, '#ffe100', '#00b341'];
    const strokes = ['match', ['get', 'lvl'], 3, '#7f1d1d', 2, '#9a3412', 1, '#854d0e', '#166534'];
    map.addLayer({
        id: srcId('alerts') + '-fill', type: 'fill', source: srcId('alerts'),
        paint: {
            'fill-color': fills,
            'fill-opacity': ['match', ['get', 'lvl'], 3, 0.88, 2, 0.84, 1, 0.78, 0.30],
        },
    }, before);
    // v1 alertStyle: weight 4.2 (livello>0) pieno / 2.6 tratteggiato '7 6' (livello 0).
    map.addLayer({
        id: srcId('alerts') + '-line', type: 'line', source: srcId('alerts'),
        filter: ['>', ['get', 'lvl'], 0],
        layout: { 'line-join': 'round' },
        paint: { 'line-color': strokes, 'line-width': 4.2, 'line-opacity': 1 },
    }, before);
    map.addLayer({
        id: srcId('alerts') + '-line0', type: 'line', source: srcId('alerts'),
        filter: ['==', ['get', 'lvl'], 0],
        layout: { 'line-join': 'round' },
        paint: {
            'line-color': '#166534', 'line-width': 2.6, 'line-opacity': 1,
            // dashArray '7 6' a weight 2.6 → unità di line-width (pattern storms.js)
            'line-dasharray': [7 / 2.6, 6 / 2.6],
        },
    }, before);
    wireInteractions('alerts', srcId('alerts') + '-fill', { atClick: true, shellClass: 'ws-alert-popup-shell' });
    return true;
}

function alertsFeatures() {
    const d = state.alertsData;
    if (!d) return [];
    return (d.geojson.features || [])
        .filter(f => String(f?.properties?.zone_code || f?.properties?.zona_codice || '').toLowerCase().startsWith('sici-'))
        .map(f => {
            const code = f.properties.zone_code || f.properties.zona_codice;
            const name = f.properties.zone_name || f.properties.zona_nome || code;
            const today = d.alertsToday.get(code);
            const tomorrow = d.alertsTomorrow.get(code);
            const todayLevel = alertLevel(today);
            const tomorrowLevel = alertLevel(tomorrow);
            const validity = today?.updated_at
                ? `Aggiornato ${new Date(today.updated_at).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' })}`
                : '';
            const tomorrowValidity = '';
            return {
                type: 'Feature',
                geometry: f.geometry,
                properties: {
                    code, todayLevel, tomorrowLevel,
                    // Livello mostrato: giorno selezionato (setAlertsDay). NB la v1
                    // colora col MAX(oggi, domani); qui il giorno è esplicito.
                    lvl: state.alertsDay === 'tomorrow' ? tomorrowLevel : todayLevel,
                    pp: alertPopupMarkup(name, code, todayLevel, tomorrowLevel, validity, tomorrowValidity),
                    mw: 330,
                },
            };
        });
}

function renderAlerts() {
    if (!state.enabled.alerts || !state.alertsData) return;
    if (!ensureAlertsLayers()) return;
    const features = alertsFeatures();
    setData('alerts', features);
    const counts = [0, 0, 0, 0];
    const tomorrowCounts = [0, 0, 0, 0];
    features.forEach(f => { counts[f.properties.todayLevel]++; tomorrowCounts[f.properties.tomorrowLevel]++; });
    const highest = counts[3] ? 'rossa' : counts[2] ? 'arancione' : counts[1] ? 'gialla' : 'verde';
    const highestTomorrow = tomorrowCounts[3] ? 'rossa' : tomorrowCounts[2] ? 'arancione' : tomorrowCounts[1] ? 'gialla' : 'verde';
    emitStatus(`<strong>Allerte meteo-idro attive.</strong> Massimo oggi: ${highest}. Domani: ${highestTomorrow}.`);
}

async function loadAlerts() {
    const seq = ++state.seq.alerts;
    emitStatus('<strong>Allerte in caricamento.</strong> Recupero zone e bollettino meteo-idro.');
    const [todayGeojson, tomorrowGeojson] = await Promise.all([
        fetchWeatherAlertsApiGeojson('today'),
        fetchWeatherAlertsApiGeojson('tomorrow')
    ]);
    const data = {
        geojson: todayGeojson,
        alertsToday: apiAlertByZone(todayGeojson),
        alertsTomorrow: apiAlertByZone(tomorrowGeojson),
    };
    if (seq !== state.seq.alerts || !state.enabled.alerts) return;
    state.alertsData = data;
    renderAlerts();
}

export function setAlertsDay(day) {
    const next = day === 'tomorrow' ? 'tomorrow' : 'today';
    if (next === state.alertsDay) return;
    state.alertsDay = next;
    renderAlerts();
}

// ---------------------------------------------------------------------------
// WILDFIRE ALERTS — allerte incendi DRPC (poligoni province)
// Port 1:1 (v1:2684-2837).
// ---------------------------------------------------------------------------

function wildfireAlertPalette(level) {
    if (level === 3) return { stroke: '#7f1d1d', fill: '#dc2626', soft: '#fee2e2', text: '#7f1d1d' };
    if (level === 2) return { stroke: '#9a3412', fill: '#f97316', soft: '#ffedd5', text: '#7c2d12' };
    if (level === 1) return { stroke: '#854d0e', fill: '#facc15', soft: '#fef9c3', text: '#713f12' };
    return { stroke: '#166534', fill: '#22c55e', soft: '#dcfce7', text: '#14532d' };
}

function wildfireAlertText(level) {
    return ['Non disponibile', 'Pericolosita bassa', 'Pericolosita media', 'Pericolosita alta'][level] || 'Non disponibile';
}

function wildfireAlertPhase(value) {
    const phase = String(value || '').toLowerCase();
    if (phase === 'attenzione') return 'Attenzione';
    if (phase === 'preallerta') return 'Preallerta';
    if (phase === 'none') return 'Nessuna fase';
    return 'Fase non indicata';
}

function formatWildfireAlertDate(value, mode) {
    const date = new Date(value);
    if (!value || Number.isNaN(date.getTime())) return '';
    const options = mode === 'date'
        ? { dateStyle: 'medium', timeZone: 'Europe/Rome' }
        : { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Rome' };
    return new Intl.DateTimeFormat('it-IT', options).format(date);
}

function wildfireAlertPopup(props) {
    const level = Math.max(0, Math.min(3, Number(props.alert_level || 0)));
    const palette = wildfireAlertPalette(level);
    const validStart = formatWildfireAlertDate(props.valid_start);
    const validEnd = formatWildfireAlertDate(props.valid_end);
    const forecastDate = formatWildfireAlertDate(props.forecast_date, 'date');
    const notice = props.notice_number ? `Avviso n. ${props.notice_number}` : (props.notice_title || 'Avviso DRPC');
    const pdf = props.pdf_url
        ? `<a href="${wsLayerEsc(props.pdf_url)}" target="_blank" rel="noopener">Apri PDF DRPC</a>`
        : '';

    return `<article class="ws-alert-popup" style="--alert-fill:${palette.fill};--alert-fg:${palette.text};--alert-line:${palette.stroke};--alert-soft:${palette.soft};">
        <header>
            <span>Rischio incendi</span>
            <strong>${wsLayerEsc(props.province_name || props.province_code || 'Provincia')}</strong>
        </header>
        <p>${wsLayerEsc(wildfireAlertText(level))} - ${wsLayerEsc(wildfireAlertPhase(props.alert_phase))}.</p>
        <div class="ws-alert-popup__rows">
            <div class="ws-alert-popup__row" style="--alert-row-fill:${palette.fill};--alert-row-fg:${palette.text};--alert-row-line:${palette.stroke};">
                <span>Livello DRPC</span>
                <strong>${wsLayerEsc(props.danger_label || wildfireAlertText(level))}</strong>
                ${forecastDate ? `<small>${wsLayerEsc(forecastDate)}</small>` : ''}
            </div>
            <div class="ws-alert-popup__row" style="--alert-row-fill:${palette.fill};--alert-row-fg:${palette.text};--alert-row-line:${palette.stroke};">
                <span>${wsLayerEsc(notice)}</span>
                <strong>${validStart && validEnd ? `${wsLayerEsc(validStart)} - ${wsLayerEsc(validEnd)}` : 'Validita non indicata'}</strong>
                ${pdf ? `<small>${pdf}</small>` : ''}
            </div>
        </div>
    </article>`;
}

async function fetchWildfireAlertsGeojson() {
    let lastError = null;
    for (const url of WILDFIRE_ALERTS_API_URLS) {
        try {
            const response = await fetch(url, { cache: 'no-store' });
            const payload = await response.json();
            if (!response.ok || payload.type !== 'FeatureCollection') {
                throw new Error(payload.error || 'WILDFIRE_ALERTS_GEOJSON_ERROR');
            }
            return payload;
        } catch (error) {
            lastError = error;
        }
    }
    throw lastError || new Error('WILDFIRE_ALERTS_UNAVAILABLE');
}

function ensureWildfireLayers() {
    const map = state.map;
    if (map.getSource(srcId('wildfireAlerts'))) return true;
    if (!styleReady('wildfireAlerts', () => { loadWildfireAlerts().catch(() => {}); })) return false;
    map.addSource(srcId('wildfireAlerts'), { type: 'geojson', data: EMPTY });
    const before = beforeStations();  // v1: wildfireAlertsPane z485
    const fills = ['match', ['get', 'lvl'], 3, '#dc2626', 2, '#f97316', 1, '#facc15', '#22c55e'];
    const strokes = ['match', ['get', 'lvl'], 3, '#7f1d1d', 2, '#9a3412', 1, '#854d0e', '#166534'];
    // v1 wildfireAlertStyle: fillOpacity .58/.20, opacity .95, weight 3.2/2, dash '6 6'
    map.addLayer({
        id: srcId('wildfireAlerts') + '-fill', type: 'fill', source: srcId('wildfireAlerts'),
        paint: {
            'fill-color': fills,
            'fill-opacity': ['case', ['>', ['get', 'lvl'], 0], 0.58, 0.20],
        },
    }, before);
    map.addLayer({
        id: srcId('wildfireAlerts') + '-line', type: 'line', source: srcId('wildfireAlerts'),
        filter: ['>', ['get', 'lvl'], 0],
        layout: { 'line-join': 'round' },
        paint: { 'line-color': strokes, 'line-width': 3.2, 'line-opacity': 0.95 },
    }, before);
    map.addLayer({
        id: srcId('wildfireAlerts') + '-line0', type: 'line', source: srcId('wildfireAlerts'),
        filter: ['==', ['get', 'lvl'], 0],
        layout: { 'line-join': 'round' },
        paint: {
            'line-color': '#166534', 'line-width': 2, 'line-opacity': 0.95,
            'line-dasharray': [3, 3],   // '6 6' a weight 2 (come storms.js)
        },
    }, before);
    wireInteractions('wildfireAlerts', srcId('wildfireAlerts') + '-fill', { atClick: true, shellClass: 'ws-alert-popup-shell' });
    return true;
}

async function loadWildfireAlerts() {
    const seq = ++state.seq.wildfireAlerts;
    const geojson = await fetchWildfireAlertsGeojson();
    if (seq !== state.seq.wildfireAlerts || !state.enabled.wildfireAlerts) return;
    if (!ensureWildfireLayers()) return;
    const counts = [0, 0, 0, 0];
    const features = (geojson.features || []).map(f => {
        const level = Math.max(0, Math.min(3, Number(f?.properties?.alert_level || 0)));
        counts[level]++;
        return {
            type: 'Feature',
            geometry: f.geometry,
            properties: {
                lvl: level,
                pp: wildfireAlertPopup(f.properties || {}),
                mw: 340,
            },
        };
    });
    setData('wildfireAlerts', features);
    const max = counts[3] ? 'alta' : counts[2] ? 'media' : counts[1] ? 'bassa' : 'non disponibile';
    const notice = geojson.metadata?.notice?.notice_number ? ` Avviso n. ${wsLayerEsc(geojson.metadata.notice.notice_number)}.` : '';
    emitStatus(`<strong>Allerte incendi DRPC attive.</strong> Massimo regionale: ${max}.${notice}`);
}

// ---------------------------------------------------------------------------
// FIRMS — hotspot incendi satellitari + arricchimento comune (point-in-polygon
// client sui confini ISTAT). Port 1:1 (v1:1914-2175).
// ---------------------------------------------------------------------------

function formatFirmsTime(value) {
    const date = new Date(value);
    if (!value || Number.isNaN(date.getTime())) return value || '--';
    return new Intl.DateTimeFormat('it-IT', {
        dateStyle: 'short',
        timeStyle: 'short',
        timeZone: 'Europe/Rome'
    }).format(date);
}

// Stile marker (port di firmsMarkerStyle: radius √FRP, MODIS arancio/VIIRS rosso,
// bordo scuro se confidenza alta).
function firmsMarkerStyle(feature) {
    const props = feature.properties || {};
    const frp = Number(props.frp || 0);
    const confidence = String(props.confidence || '').toLowerCase();
    const highConfidence = confidence === 'h' || confidence === 'high' || Number(confidence) >= 80;
    const isModis = String(props.instrument || '').toUpperCase() === 'MODIS';
    return {
        radius: Math.max(5, Math.min(14, 5 + Math.sqrt(Math.max(0, frp)) * 0.8)),
        color: highConfidence ? '#7f1d1d' : '#a84712',
        weight: 1.5,
        fillColor: isModis ? '#f97316' : '#ef4444',
        fillOpacity: highConfidence ? 0.78 : 0.56
    };
}

function firmsConfidenceLabel(value) {
    const raw = String(value || '').toLowerCase();
    const numeric = Number(raw);
    if (raw === 'h' || raw === 'high' || numeric >= 80) {
        return { label: 'Alta', note: 'rilevamento molto affidabile' };
    }
    if (raw === 'l' || raw === 'low' || (Number.isFinite(numeric) && numeric < 30)) {
        return { label: 'Bassa', note: 'da verificare con altre fonti' };
    }
    if (raw === 'n' || raw === 'nominal' || raw === 'normal') {
        return { label: 'Normale', note: 'rilevamento attendibile' };
    }
    if (Number.isFinite(numeric)) {
        return { label: `${numeric}%`, note: numeric >= 60 ? 'buona affidabilita' : 'da verificare' };
    }
    return { label: 'Non indicata', note: 'dato non disponibile' };
}

function firmsIntensityLabel(frpValue) {
    const frp = Number(frpValue);
    if (!Number.isFinite(frp)) {
        return { label: 'Non stimata', note: 'energia non disponibile', technical: '--' };
    }
    if (frp >= 50) {
        return { label: 'Molto intensa', note: 'segnale termico forte', technical: `${frp.toFixed(1)} MW` };
    }
    if (frp >= 15) {
        return { label: 'Intensa', note: 'segnale termico elevato', technical: `${frp.toFixed(1)} MW` };
    }
    if (frp >= 5) {
        return { label: 'Moderata', note: 'segnale termico rilevante', technical: `${frp.toFixed(1)} MW` };
    }
    return { label: 'Debole', note: 'segnale termico contenuto', technical: `${frp.toFixed(1)} MW` };
}

let firmsMunicipalityIndexPromise = null;

function firmsCoordinatesBbox(coordinates, bbox = null) {
    if (Array.isArray(coordinates) &&
        Number.isFinite(Number(coordinates[0])) &&
        Number.isFinite(Number(coordinates[1]))) {
        const lng = Number(coordinates[0]);
        const lat = Number(coordinates[1]);
        return bbox
            ? [Math.min(bbox[0], lng), Math.min(bbox[1], lat), Math.max(bbox[2], lng), Math.max(bbox[3], lat)]
            : [lng, lat, lng, lat];
    }
    if (!Array.isArray(coordinates)) return bbox;
    return coordinates.reduce((current, child) => firmsCoordinatesBbox(child, current), bbox);
}

function firmsPointInBbox(lat, lng, bbox) {
    return lng >= bbox[0] && lng <= bbox[2] && lat >= bbox[1] && lat <= bbox[3];
}

function firmsPointInRing(lat, lng, ring) {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const xi = Number(ring[i]?.[0]);
        const yi = Number(ring[i]?.[1]);
        const xj = Number(ring[j]?.[0]);
        const yj = Number(ring[j]?.[1]);
        if (!Number.isFinite(xi) || !Number.isFinite(yi) || !Number.isFinite(xj) || !Number.isFinite(yj)) continue;
        const intersects = ((yi > lat) !== (yj > lat)) &&
            (lng < (xj - xi) * (lat - yi) / ((yj - yi) || Number.EPSILON) + xi);
        if (intersects) inside = !inside;
    }
    return inside;
}

function firmsPointInPolygon(lat, lng, polygon) {
    if (!Array.isArray(polygon) || !polygon.length || !firmsPointInRing(lat, lng, polygon[0])) return false;
    return !polygon.slice(1).some(ring => firmsPointInRing(lat, lng, ring));
}

function firmsGeometryContainsPoint(geometry, lat, lng) {
    if (geometry?.type === 'Polygon') return firmsPointInPolygon(lat, lng, geometry.coordinates);
    if (geometry?.type === 'MultiPolygon') {
        return (geometry.coordinates || []).some(polygon => firmsPointInPolygon(lat, lng, polygon));
    }
    return false;
}

async function firmsMunicipalityIndex() {
    if (!firmsMunicipalityIndexPromise) {
        firmsMunicipalityIndexPromise = fetch(MUNICIPALITIES_GEOJSON_URL, { cache: 'force-cache' })
            .then(response => {
                if (!response.ok) throw new Error(`FIRMS_MUNICIPALITIES_${response.status}`);
                return response.json();
            })
            .then(geojson => (geojson.features || [])
                .map(feature => {
                    const geometry = feature?.geometry || null;
                    const bbox = firmsCoordinatesBbox(geometry?.coordinates);
                    if (!geometry || !bbox) return null;
                    const props = feature.properties || {};
                    return {
                        bbox,
                        geometry,
                        place: {
                            municipality_code: props.municipality_code || '',
                            municipality_name: props.municipality_name || '',
                            province_code: props.province_code || '',
                            province_name: props.province_name || ''
                        }
                    };
                })
                .filter(Boolean));
    }
    return firmsMunicipalityIndexPromise;
}

async function enrichFirmsMunicipalities(geojson) {
    const features = Array.isArray(geojson?.features) ? geojson.features : [];
    const missing = features.some(feature => !feature?.properties?.municipality_name);
    if (!missing) return geojson;

    try {
        const index = await firmsMunicipalityIndex();
        features.forEach(feature => {
            const coords = feature?.geometry?.coordinates || [];
            const lng = Number(coords[0]);
            const lat = Number(coords[1]);
            if (!Number.isFinite(lat) || !Number.isFinite(lng) || feature.properties?.municipality_name) return;
            const match = index.find(entry =>
                firmsPointInBbox(lat, lng, entry.bbox) &&
                firmsGeometryContainsPoint(entry.geometry, lat, lng)
            );
            if (match) feature.properties = { ...(feature.properties || {}), ...match.place };
        });
    } catch (error) {
        console.warn('Comuni incendi non disponibili:', error);
    }

    return geojson;
}

function firmsPlaceLabel(props) {
    const municipality = props.municipality_name || props.municipality || '';
    const province = props.province_code || props.province_name || '';
    if (municipality && province) return `${municipality} (${province})`;
    return municipality || province || 'Non determinato';
}

function firmsPopup(feature) {
    const props = feature.properties || {};
    const coords = feature.geometry?.coordinates || [];
    const confidence = firmsConfidenceLabel(props.confidence);
    const intensity = firmsIntensityLabel(props.frp);
    const instrument = [props.instrument, props.satellite].filter(Boolean).join(' ');
    return `<article class="ws-firms-popup">
        <header>
            <strong>Incendi</strong>
            <span>${wsLayerEsc(instrument || 'Rilevamento satellitare')}</span>
        </header>
        <p class="ws-firms-summary">Punto caldo rilevato dal satellite: indica una possibile area di incendio o combustione recente.</p>
        <dl class="ws-firms-main">
            <div>
                <dt>Quando</dt>
                <dd><strong>${wsLayerEsc(formatFirmsTime(props.acq_datetime))}</strong><span>ora locale italiana</span></dd>
            </div>
            <div>
                <dt>Comune</dt>
                <dd><strong>${wsLayerEsc(firmsPlaceLabel(props))}</strong><span>stima da confini comunali ISTAT</span></dd>
            </div>
            <div>
                <dt>Intensita</dt>
                <dd><strong>${wsLayerEsc(intensity.label)}</strong><span>${wsLayerEsc(intensity.note)} (${wsLayerEsc(intensity.technical)})</span></dd>
            </div>
            <div>
                <dt>Affidabilita</dt>
                <dd><strong>${wsLayerEsc(confidence.label)}</strong><span>${wsLayerEsc(confidence.note)}</span></dd>
            </div>
        </dl>
        <dl class="ws-firms-details">
            <div><dt>Coordinate</dt><dd>${Number(coords[1]).toFixed(5)}, ${Number(coords[0]).toFixed(5)}</dd></div>
        </dl>
    </article>`;
}

function ensureFirmsLayer() {
    const map = state.map;
    if (map.getSource(srcId('firms'))) return true;
    if (!styleReady('firms', () => { loadFirms().catch(() => {}); })) return false;
    map.addSource(srcId('firms'), { type: 'geojson', data: EMPTY });
    map.addLayer({
        id: srcId('firms'), type: 'circle', source: srcId('firms'),
        paint: {
            'circle-radius': ['get', 'r'],
            'circle-color': ['get', 'fill'],
            'circle-opacity': ['get', 'fillOp'],
            'circle-stroke-color': ['get', 'stroke'],
            'circle-stroke-width': 1.5,
        },
    }, beforeStations());
    wireInteractions('firms', srcId('firms'), { shellClass: 'ws-firms-popup-shell' });
    return true;
}

async function loadFirms() {
    const seq = ++state.seq.firms;
    const url = `${FIRMS_API_URL}?period=today&format=geojson`;
    const response = await fetch(url, { cache: 'no-store' });
    const geojson = await response.json();
    if (!response.ok || geojson.type !== 'FeatureCollection') {
        throw new Error(geojson.error || 'FIRMS_GEOJSON_ERROR');
    }
    await enrichFirmsMunicipalities(geojson);
    if (seq !== state.seq.firms || !state.enabled.firms) return;
    if (!ensureFirmsLayer()) return;

    const features = (geojson.features || [])
        .filter(f => f?.geometry?.type === 'Point' && Array.isArray(f.geometry.coordinates))
        .map(f => {
            const style = firmsMarkerStyle(f);
            return {
                type: 'Feature',
                geometry: f.geometry,
                properties: {
                    r: style.radius,
                    fill: style.fillColor,
                    fillOp: style.fillOpacity,
                    stroke: style.color,
                    pp: firmsPopup(f),
                    mw: 340,
                },
            };
        });
    setData('firms', features);

    const last = geojson.metadata?.last_success_at ? formatFirmsTime(geojson.metadata.last_success_at) : 'cache non aggiornata';
    emitStatus(`<strong>Incendi.</strong> ${(geojson.features || []).length} hotspot satellitari rilevati oggi, ultimo sync: ${wsLayerEsc(last)}.`);
}

// ---------------------------------------------------------------------------
// ETNA — stato vulcano (codice colore aviazione + cenere + termico MIROVA)
// Port 1:1 (v1:685-735); badge divIcon (.ws-etna-badge: 30px, bg colore
// aviazione, anello bianco 2px via box-shadow, 🌋 16px) → sprite canvas.
// NB MapLibre vuole [lon, lat]: la v1 marca L.marker([37.748, 15.004]).
// ---------------------------------------------------------------------------

const WS_ETNA_COLORS = { GREEN: '#2e9e3f', YELLOW: '#e8c20a', ORANGE: '#ef7d18', RED: '#d6322a' };
const ETNA_LNGLAT = [15.004, 37.748];

function etnaSpriteKey(col) { return `ws-risk|etna|${col}`; }

function buildEtnaSprite(col) {
    // CSS v1: box-shadow 0 0 0 2px #fff (anello esterno), 0 1px 5px rgba(0,0,0,.45)
    return circleBadgeSprite({
        size: 30, fill: col, ringColor: '#ffffff', ringWidth: 2, ringPos: 'outside',
        shadow: { color: 'rgba(0,0,0,.45)', blur: 5, dy: 1 },
        content: (ctx, cx, cy) => {
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '16px Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, "Apple Color Emoji", "Segoe UI Emoji"';
            ctx.fillText('🌋', cx, cy + 1);
        },
    });
}

// Mini-grafico SVG del tremore vulcanico (stile "segnale in tempo reale" INGV):
// linea del valore + fondo (quiete) tratteggiato + soglie WATCH/ALERT.
function tremorChartSvg(data, tremor) {
    const s = (data && data.series) || [];
    if (s.length < 2) return '';
    const base = data.baseline || null;
    const W = 300, H = 92, PL = 6, PR = 6, PT = 8, PB = 16;
    const vals = s.map(p => p[1]);
    const watch = base ? base * 2 : null, alert = base ? base * 3 : null;
    const ymax = Math.max(...vals, alert || 0) * 1.12 || 1;
    const iw = W - PL - PR, ih = H - PT - PB;
    const x = i => PL + (iw * i / (s.length - 1));
    const y = v => PT + ih * (1 - Math.min(v, ymax) / ymax);
    const line = s.map((p, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(p[1]).toFixed(1)}`).join(' ');
    const area = `${line} L${x(s.length - 1).toFixed(1)},${(PT + ih).toFixed(1)} L${PL},${(PT + ih).toFixed(1)} Z`;
    const st = (tremor && tremor.status) || 'NORMAL';
    const stroke = st === 'ALERT' ? '#d6322a' : st === 'WATCH' ? '#ef7d18' : '#2e9e3f';
    const hline = (v, color, dash, lbl) => v == null || v > ymax ? '' :
        `<line x1="${PL}" x2="${W - PR}" y1="${y(v).toFixed(1)}" y2="${y(v).toFixed(1)}" stroke="${color}" stroke-width="1" stroke-dasharray="${dash}" opacity="0.7"/>` +
        `<text x="${W - PR}" y="${(y(v) - 2).toFixed(1)}" text-anchor="end" font-size="8" fill="${color}" opacity="0.9">${lbl}</text>`;
    // etichette temporali: primo e ultimo
    const t0 = s[0][0].slice(5, 16).replace('-', '/'), t1 = s[s.length - 1][0].slice(5, 16).replace('-', '/');
    return `<div class="ws-etna-chart"><svg viewBox="0 0 ${W} ${H}" width="100%" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Andamento del tremore vulcanico ultime 48 ore">
        <path d="${area}" fill="${stroke}" opacity="0.10"/>
        ${hline(alert, '#d6322a', '4 3', 'forte')}
        ${hline(watch, '#ef7d18', '4 3', 'attenz.')}
        ${base != null ? `<line x1="${PL}" x2="${W - PR}" y1="${y(base).toFixed(1)}" y2="${y(base).toFixed(1)}" stroke="#6b7280" stroke-width="1" stroke-dasharray="2 2" opacity="0.6"/><text x="${PL}" y="${(y(base) - 2).toFixed(1)}" font-size="8" fill="#6b7280">fondo</text>` : ''}
        <path d="${line}" fill="none" stroke="${stroke}" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/>
        <text x="${PL}" y="${H - 4}" font-size="8" fill="#9aa0a6">${t0}</text>
        <text x="${W - PR}" y="${H - 4}" text-anchor="end" font-size="8" fill="#9aa0a6">${t1}</text>
      </svg></div>`;
}

// Popup (port ESATTO v1:698-728: linguaggio semplice voli/cenere/termico).
function etnaPopupHtml(d, col) {
    const code = (d.aviation_colour || '').toUpperCase();
    const aviaPlain = {
        GREEN: 'Vulcano tranquillo, attività normale',
        YELLOW: 'Segni di risveglio, attività in aumento',
        ORANGE: 'Attività elevata: possibile emissione di cenere',
        RED: 'Eruzione in corso o imminente con cenere'
    }[code] || 'Stato non disponibile';
    const ashTxt = (d.ash_detail || '').toUpperCase();
    const ashPlain = (!d.ash) ? 'Nessun dato sulla cenere'
        : (/STOP|NO VA|NOT IDENT/.test(ashTxt) ? 'Nessuna nube di cenere in atmosfera'
            : 'Nube di cenere segnalata: possibili disagi ai voli');
    const vrpVal = d.thermal_vrp_mw;
    const thermPlain = (vrpVal == null) ? 'Dato termico non disponibile'
        : (vrpVal < 1 ? 'Nessuna anomalia termica dal satellite'
            : vrpVal < 30 ? 'Debole calore rilevato dal satellite'
                : vrpVal < 200 ? 'Calore moderato (possibile lava)'
                    : 'Forte calore: attività effusiva (lava) in corso');
    const summary = (code === 'RED' || (vrpVal || 0) >= 200) ? 'Attività rilevante in corso'
        : (code === 'ORANGE' || (vrpVal || 0) >= 30 || /SEGNAL/.test(ashPlain.toUpperCase())) ? "Vulcano attivo, da tenere d'occhio"
            : 'Situazione tranquilla';
    const fmtDate = s => { if (!s) return ''; const p = String(s).split(' '); return p[0] ? p[0].split('-').reverse().join('/') + (p[1] ? ' ' + p[1].slice(0, 5) : '') : s; };
    // Cenere: direzione di deriva (se disponibile dal VAAC)
    const ashKm = flToKm(d.ash_fl_max);
    const ashDir = d.ash_dir_it
        ? `<br><small>La cenere deriva verso <b>${d.ash_dir_it}</b>${ashKm ? `, fino a ~${ashKm} km di quota` : ''}${d.ash_horizon_h ? ` · prossime ${d.ash_horizon_h}h` : ''}</small>`
        : '';
    // Legenda concentrazione (quando il pennacchio è il modello FALL3D-like VAAC)
    let ashLegend = '';
    if (etnaPlumeMeta && etnaPlumeMeta.mode === 'concentration') {
        const chip = (c, t) => `<span style="display:inline-flex;align-items:center;gap:3px;margin-right:7px"><i style="width:9px;height:9px;border-radius:2px;background:${c};display:inline-block"></i>${t}</span>`;
        ashLegend = `<br><small class="ws-etna-legend">Concentrazione: ${chip('#6CACD4', 'bassa')}${chip('#FE9829', 'media')}${chip('#CC1620', 'alta')}${chip('#49006B', 'molto alta')}<br>Usa il cursore per scegliere l'ora della previsione.</small>`;
    } else if (etnaPlumeMeta) {
        ashLegend = `<br><small class="ws-etna-legend">Perimetro della nube VAAC: senza stima della ricaduta al suolo. Usa il cursore per separare gli orari.</small>`;
    }
    ashLegend += '<br><a href="https://wslam.weathersicily.it/ceneri/" target="_blank" rel="noopener">Ceneri Etna · osservazioni e previsioni ↗</a>';
    const ashImg = d.ash_image_url
        ? `<br><a class="ws-etna-vaac" href="${d.ash_image_url}" target="_blank" rel="noopener">🖼️ Bollettino ufficiale VAAC ↗</a>`
        : '';
    // Banner previsione WS Now – Eruption (tier multiparametro)
    const fc = d.forecast;
    const fcCol = { 0: '#2e9e3f', 1: '#e8c20a', 2: '#ef7d18', 3: '#d6322a' };
    const fcBanner = (fc && fc.tier != null)
        ? `<div class="ws-etna-fc" style="border-left:3px solid ${fcCol[fc.tier] || '#888'}">
             <b>Previsione · WS Now – Eruption</b><br>${fc.label || ''}${fc.ratio != null ? ` <small>(tremore ${String(fc.ratio).replace('.', ',')}× il fondo${fc.src_dist_km != null ? `, sorgente ${String(fc.src_dist_km).replace('.', ',')} km dai crateri` : ''})</small>` : ''}</div>`
        : '';
    // Tremore vulcanico: stato + grafico
    const tr = d.tremor;
    let tremorLi = '';
    if (tr && tr.status) {
        const tCol = tr.status === 'ALERT' ? '#d6322a' : tr.status === 'WATCH' ? '#ef7d18' : '#2e9e3f';
        const tWord = tr.status === 'ALERT' ? 'anomalia forte' : tr.status === 'WATCH' ? 'in aumento (attenzione)' : 'nella norma';
        const ratioTxt = (tr.ratio != null) ? ` <small>(${String(tr.ratio).replace('.', ',')}× il fondo)</small>` : '';
        tremorLi = `<li><span class="ws-etna-pop__ic">📈</span><div><b>Tremore vulcanico</b><br>
            <span style="color:${tCol};font-weight:600">${tWord}</span>, ${tr.trend}${ratioTxt}
            ${tremorChartSvg(etnaTremorSeries, tr)}</div></li>`;
    }
    return `<article class="ws-etna-pop">
          <header class="ws-etna-pop__top"><span class="ws-etna-pop__dot" style="background:${col}"></span>
            <div><h3>Etna — stato attuale</h3><strong>${summary}</strong></div></header>
          ${fcBanner}
          <ul class="ws-etna-pop__list">
            ${tremorLi}
            <li><span class="ws-etna-pop__ic">✈️</span><div><b>Voli &amp; aeroporto</b><br>${aviaPlain} <small>(codice ${code || 'n.d.'}, ${fmtDate(d.aviation_time)})</small></div></li>
            <li><span class="ws-etna-pop__ic">🌫️</span><div><b>Cenere in aria</b><br>${ashPlain}${ashDir}${ashLegend}${ashImg}</div></li>
            <li><span class="ws-etna-pop__ic">🌡️</span><div><b>Calore / lava</b><br>${thermPlain} <small>${vrpVal != null ? '(' + vrpVal + ' MW)' : ''}</small></div></li>
          </ul>
          <footer class="ws-etna-pop__src">Fonti ufficiali: ${d.sources || ''}</footer>
        </article>`;
}

// Crea in UN SOLO giro (un solo gate styleReady) sia il pennacchio (sotto) sia
// il badge (sopra): aggiungere un source GeoJSON rende isStyleLoaded() falso, per
// cui separare le due creazioni rimanderebbe sempre la seconda a un idle successivo.
function ensureEtnaLayer() {
    const map = state.map;
    if (map.getSource(srcId('etna'))) return true;
    if (!styleReady('etna', () => { loadEtna().catch(() => {}); })) return false;
    const before = beforeStations();
    // --- pennacchio di cenere: contorni di CONCENTRAZIONE del modello VAAC (FALL3D-like),
    // colorati per soglia con la palette ufficiale (blu→arancio→rosso→viola), smussati.
    map.addSource(srcId('etnaPlume'), { type: 'geojson', data: EMPTY });
    map.addLayer({
        id: srcId('etnaPlume') + '-fill', type: 'fill', source: srcId('etnaPlume'),
        filter: ['==', ['get', 'ti'], etnaTi],
        paint: {
            'fill-color': ['coalesce', ['get', 'fill'], '#888'],
            // Intensità progressiva: i dati a soglia possono fornire la loro
            // opacità, altrimenti resta la scala standard di concentrazione.
            'fill-opacity': ['coalesce', ['get', 'opacity'],
                ['match', ['get', 'sev'], 3, 0.42, 2, 0.34, 1, 0.26, 0.18]],
        },
    }, before);
    map.addLayer({
        id: srcId('etnaPlume') + '-line', type: 'line', source: srcId('etnaPlume'),
        filter: ['==', ['get', 'ti'], etnaTi],
        layout: { 'line-join': 'round' },
        paint: {
            'line-color': ['coalesce', ['get', 'stroke'], '#555'],
            'line-width': ['coalesce', ['get', 'lineWidth'], 0.8],
            'line-opacity': ['coalesce', ['get', 'lineOpacity'], 0.55],
        },
    }, before);
    wireInteractions('etnaPlume', srcId('etnaPlume') + '-fill', { atClick: true });
    // --- badge stato (sopra tutto, niente beforeId) ---
    map.addSource(srcId('etna'), { type: 'geojson', data: EMPTY });
    map.addLayer({
        id: srcId('etna'), type: 'symbol', source: srcId('etna'),
        layout: {
            'icon-image': ['get', 'icon'],
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
        },
    });
    wireInteractions('etna', srcId('etna'), { shellClass: 'ws-etna-pop-shell' });
    return true;
}

function plumeFeatures(fc) {
    return (fc && fc.features || []).flatMap((f, index) => {
        const p = f.properties || {};
        if (p.fill) {  // contorni di concentrazione del modello (VAAC qva)
            return [{
                type: 'Feature', geometry: f.geometry,
                properties: { fill: p.fill, stroke: p.stroke, sev: p.sev || 0, opacity: p.opacity || 0.34, ti: p.ti || 0,
                    tt: `Cenere in aria: concentrazione ${p.lab_it || ''}` },
            }];
        }
        // A VAA perimeter has no deposition intensity information.
        return [{ type: 'Feature', geometry: f.geometry, properties: {
            fill: '#ffd166', stroke: '#c59a18', opacity: 0.15,
            lineWidth: 1.4, lineOpacity: 0.8, sev: 0, ti: index,
            tt: `Perimetro della nube VAAC${p.label ? ` · ${p.label}` : ''}. Non indica la ricaduta al suolo.`,
        } }];
    });
}

function advisoryPlumeSteps(fc) {
    const features = (fc && fc.features || []).filter(f => !(f.properties || {}).fill);
    if (features.length < 2) return null;
    return features.map((f, index) => {
        const p = f.properties || {};
        const hour = Number.isFinite(Number(p.hour)) ? Number(p.hour) : index;
        return { label: p.label || (hour ? `prevista +${hour}h` : 'osservata ora'), hour };
    });
}

async function loadEtna() {
    const seq = ++state.seq.etna;
    // bucket 2 min: durante un'eruzione live i dati cambiano spesso e il CF Edge
    // TTL (4h) va aggirato con un URL nuovo più di frequente.
    const bust = '?_=' + Math.floor(Date.now() / 120000);
    const [statusRes, plumeRes, seriesRes] = await Promise.allSettled([
        fetch(ETNA_STATUS_URL + bust, { cache: 'no-store' }).then(r => r.json()),
        fetch(ETNA_PLUME_URL + bust, { cache: 'no-store' }).then(r => r.json()),
        fetch(ETNA_TREMOR_SERIES_URL + bust, { cache: 'no-store' }).then(r => r.json()),
    ]);
    if (seq !== state.seq.etna || !state.enabled.etna) return;
    if (statusRes.status !== 'fulfilled') throw statusRes.reason || new Error('etna status');
    const d = statusRes.value;
    etnaTremorSeries = seriesRes.status === 'fulfilled' ? seriesRes.value : null;
    const plumeFc = plumeRes.status === 'fulfilled' ? plumeRes.value : null;
    etnaPlumeMeta = plumeFc && plumeFc.properties || null;  // PRIMA del popup (usa la legenda)
    // ensureEtnaLayer crea badge + pennacchio in un solo giro
    if (!ensureEtnaLayer()) return;
    const col = WS_ETNA_COLORS[(d.aviation_colour || '').toUpperCase()] || '#888';
    const icon = etnaSpriteKey(col);
    ensureImage(icon, () => buildEtnaSprite(col));
    setData('etna', [{
        type: 'Feature',
        geometry: { type: 'Point', coordinates: ETNA_LNGLAT },
        properties: { icon, pp: etnaPopupHtml(d, col), mw: 320 },
    }]);
    setData('etnaPlume', plumeFc ? plumeFeatures(plumeFc) : []);
    // Con le aree VAAC tradizionali il cursore separa osservazione e scadenze:
    // sulla mappa deve comparire un solo poligono alla volta.
    const plumeSteps = etnaPlumeMeta && etnaPlumeMeta.mode === 'concentration'
        ? etnaPlumeMeta.steps
        : advisoryPlumeSteps(plumeFc);
    if (plumeSteps) {
        ensureEtnaSlider(plumeSteps, etnaPlumeMeta && etnaPlumeMeta.now_ti);
    } else {
        removeEtnaSlider();
    }
}

// ---------------------------------------------------------------------------
// WATER RESOURCES — invasi (marker % riempimento + popup)
// Port da map-water-resources.js (dashboard /v1/reservoirs; il pannello
// laterale storico/geo-layer della v1 NON è portato: solo marker+popup).
// Badge divIcon (.ws-water-marker: 30px, bordo 2px bianco, sigla provincia,
// colore per % riempimento) → sprite canvas.
// ---------------------------------------------------------------------------

function reservoirColor(item) {
    const percent = Number(item.percent);
    let color = '#0f766e';
    if (Number.isFinite(percent) && percent < 25) color = '#be123c';
    else if (Number.isFinite(percent) && percent < 50) color = '#d97706';
    return color;
}

function waterSpriteKey(color, province) { return `ws-risk|water|${color}|${province}`; }

function buildWaterSprite(color, province) {
    // CSS v1: 30×30, border 2px #fff (border-box), box-shadow 0 8px 22px
    // rgba(0,0,0,.32), testo provincia 10px/900 bianco.
    return circleBadgeSprite({
        size: 30, fill: color, ringColor: '#ffffff', ringWidth: 2, ringPos: 'inside',
        shadow: { color: 'rgba(0,0,0,.32)', blur: 22, dy: 8 },
        content: (ctx, cx, cy) => {
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '900 10px Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial';
            ctx.fillStyle = '#fff';
            ctx.fillText(String(province || ''), cx, cy + 0.5);
        },
    });
}

// Popup invaso RICCO: usa tutti i campi dell'API /v1/reservoirs (fiume, diga,
// comune, uso, gestore, capacità, quanto manca al colmo, barra colorata per
// livello). I campi assenti (None) non compaiono.
function waterMarkerPopup(item) {
    const n = (v) => (v == null || v === '' || !Number.isFinite(Number(v))) ? null : Number(v);
    const pct = item.percent == null ? null : Math.max(0, Math.min(100, Number(item.percent)));
    const barColor = reservoirColor(item);        // rosso <25, arancio <50, verde-acqua sopra
    const cap = n(item.capacity_mcm);
    const vol = n(item.volume_mcm);
    const toFull = (cap != null && vol != null) ? Math.max(0, cap - vol) : null;
    const useful = n(item.useful_volume_m3);
    // data DD/MM/YYYY
    let dateLabel = item.measure_date ? String(item.measure_date) : '';
    const md = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateLabel);
    if (md) dateLabel = `${md[3]}/${md[2]}/${md[1]}`;

    const rows = [];
    const add = (label, value) => { if (value != null && value !== '') rows.push(`<div><dt>${label}</dt><dd>${wsLayerEsc(String(value))}</dd></div>`); };
    add('Capacità', cap != null ? `${formatNumber(cap, 2)} Mm³` : null);
    add('Manca al colmo', toFull != null ? `${formatNumber(toFull, 2)} Mm³` : null);
    add('Diga', item.lake);
    add('Fiume', item.river);
    add('Comune', item.municipality ? `${item.municipality}${item.province ? ` (${item.province})` : ''}` : null);
    add('Uso', item.use_type);
    add('Quota', n(item.quota_m) != null ? `${formatNumber(n(item.quota_m), 2)} m` : null);
    add('Volume utile', useful != null ? `${formatNumber(useful / 1e6, 2)} Mm³` : null);
    add('Gestore', item.manager);

    return `<article class="ws-water-popup ws-water-popup--reservoir">
        <div class="ws-water-popup__top">
            <span class="ws-water-popup__badge">💧 Invaso</span>
            ${dateLabel ? `<span class="ws-water-popup__date">📅 ${wsLayerEsc(dateLabel)}</span>` : ''}
        </div>
        <h3>${wsLayerEsc(item.name)}</h3>
        <div class="ws-water-popup__hero">
            <div class="ws-water-popup__vol"><b>${vol != null ? formatNumber(vol, 2) : '–'}</b><span>Mm³</span></div>
            ${pct == null ? '' : `<div class="ws-water-popup__pct" style="color:${barColor}">${formatNumber(pct, 1)}%<small>pieno</small></div>`}
        </div>
        ${pct == null ? '' : `<div class="ws-water-popup__bar"><span style="width:${pct.toFixed(1)}%;background:${barColor}"></span></div>
        ${cap != null ? `<div class="ws-water-popup__scale"><span>vuoto</span><span>${formatNumber(cap, 0)} Mm³</span></div>` : ''}`}
        ${rows.length ? `<dl>${rows.join('')}</dl>` : ''}
    </article>`;
}

function ensureWaterLayer() {
    const map = state.map;
    if (map.getSource(srcId('waterResources'))) return true;
    if (!styleReady('waterResources', () => { loadWaterResources().catch(() => {}); })) return false;
    map.addSource(srcId('waterResources'), { type: 'geojson', data: EMPTY });
    // v1: wsWaterMarkerPane z625, sopra i marker stazione → niente beforeId.
    map.addLayer({
        id: srcId('waterResources'), type: 'symbol', source: srcId('waterResources'),
        layout: {
            'icon-image': ['get', 'icon'],
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
        },
    });
    wireInteractions('waterResources', srcId('waterResources'), { shellClass: 'ws-water-popup-shell' });
    return true;
}

async function loadWaterResources() {
    const seq = ++state.seq.waterResources;
    // getJson v1: fetch nudo, credentials omit; payload.data || payload.
    const response = await fetch(RESERVOIRS_API, { cache: 'no-store', credentials: 'omit' });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.ok === false || payload.success === false) {
        throw new Error(payload.error?.message || payload.error || 'Risorse idriche non disponibili');
    }
    const dashboard = payload.data || payload;
    if (seq !== state.seq.waterResources || !state.enabled.waterResources) return;
    if (!ensureWaterLayer()) return;
    const features = [];
    (dashboard.items || []).forEach(item => {
        const lat = Number(item.lat);
        const lng = Number(item.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
        const color = reservoirColor(item);
        const province = String(item.province || '');
        const icon = waterSpriteKey(color, province);
        ensureImage(icon, () => buildWaterSprite(color, province));
        features.push({
            type: 'Feature',
            geometry: { type: 'Point', coordinates: [lng, lat] },
            properties: { icon, pp: waterMarkerPopup(item), mw: 340 },
        });
    });
    setData('waterResources', features);
}

// ---------------------------------------------------------------------------
// RIVERS — portata fiumi GloFAS (Open-Meteo Flood). Port 1:1 (v1:1070-1098);
// badge divIcon (.ws-river-badge: 24px, anello bianco 2px, 🏞️) → sprite.
// ---------------------------------------------------------------------------

function wsRiverColor(d) { if (d == null) return '#9aa'; return d >= 50 ? '#d6322a' : d >= 10 ? '#e8590c' : d >= 1 ? '#2f9e44' : '#1c7ed6'; }

function riverSpriteKey(col) { return `ws-risk|river|${col}`; }

function buildRiverSprite(col) {
    // CSS v1: box-shadow 0 0 0 2px #fff (anello esterno), 0 1px 3px rgba(0,0,0,.4)
    return circleBadgeSprite({
        size: 24, fill: col, ringColor: '#ffffff', ringWidth: 2, ringPos: 'outside',
        shadow: { color: 'rgba(0,0,0,.4)', blur: 3, dy: 1 },
        content: (ctx, cx, cy) => {
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '12px Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, "Apple Color Emoji", "Segoe UI Emoji"';
            ctx.fillText('🏞️', cx, cy + 1);
        },
    });
}

// Popup con serie 5 giorni (port ESATTO v1:1086-1089).
function riverPopup(rv, col) {
    const trs = (rv.series || []).slice(0, 5).map(s => { const dd = String(s.day).slice(8, 10) + '/' + String(s.day).slice(5, 7); return `<tr><td>${dd}</td><td>${s.discharge != null ? s.discharge + ' m³/s' : '-'}</td></tr>`; }).join('');
    return `<article class="ws-etna-pop"><header class="ws-etna-pop__top"><span class="ws-etna-pop__dot" style="background:${col}"></span><div><h3>${rv.name} 🏞️</h3><strong>Portata del fiume (previsione)</strong></div></header>
        <div style="padding:10px 14px"><table class="ws-ecmwf-tbl"><thead><tr><th>Giorno</th><th>Portata</th></tr></thead><tbody>${trs}</tbody></table></div>
        <footer class="ws-etna-pop__src">Modello GloFAS · Fonte: Open-Meteo Flood</footer></article>`;
}

function ensureRiversLayer() {
    const map = state.map;
    if (map.getSource(srcId('rivers'))) return true;
    if (!styleReady('rivers', () => { loadRivers().catch(() => {}); })) return false;
    map.addSource(srcId('rivers'), { type: 'geojson', data: EMPTY });
    // v1: L.marker zIndexOffset 760 (pane marker) → sopra le stazioni.
    map.addLayer({
        id: srcId('rivers'), type: 'symbol', source: srcId('rivers'),
        layout: {
            'icon-image': ['get', 'icon'],
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
        },
    });
    wireInteractions('rivers', srcId('rivers'), { shellClass: 'ws-etna-pop-shell' });
    return true;
}

async function loadRivers() {
    const seq = ++state.seq.rivers;
    const r = await fetch(RIVERS_URL + '?_=' + Math.floor(Date.now() / 3600000));
    const d = await r.json();
    if (seq !== state.seq.rivers || !state.enabled.rivers) return;
    if (!ensureRiversLayer()) return;
    const features = [];
    (d.rivers || []).forEach(rv => {
        if (rv.lat == null || rv.lon == null) return;
        const col = wsRiverColor(rv.discharge);
        const icon = riverSpriteKey(col);
        ensureImage(icon, () => buildRiverSprite(col));
        features.push({
            type: 'Feature',
            geometry: { type: 'Point', coordinates: [rv.lon, rv.lat] },
            properties: { icon, pp: riverPopup(rv, col), mw: 300 },
        });
    });
    setData('rivers', features);
}

// ---------------------------------------------------------------------------
// BATHING — balneazione EEA + stato mare live (Open-Meteo Marine per celle
// 0.2°). Port 1:1 (v1:977-1068): fill = qualità EEA, anello = stato mare.
// ---------------------------------------------------------------------------

const WS_BW_COLORS = { Excellent: '#1c7ed6', Good: '#2f9e44', Sufficient: '#f0c000', Poor: '#d6322a' };
const WS_BW_LABEL = { Excellent: 'Eccellente', Good: 'Buona', Sufficient: 'Sufficiente', Poor: 'Scarsa', 'Not classified': 'Non classificata' };

const WS_SEA_STATE = [
    { max: 0.5, label: 'calmo', color: '#2dd4bf' },
    { max: 1.25, label: 'poco mosso', color: '#facc15' },
    { max: 2.5, label: 'mosso', color: '#f97316' },
    { max: Infinity, label: 'molto mosso', color: '#be123c' }
];
const WS_SEA_STEP = 0.2;

function wsSeaCellKey(lat, lon) {
    return (Math.round(lat / WS_SEA_STEP) * WS_SEA_STEP).toFixed(2) + ',' +
           (Math.round(lon / WS_SEA_STEP) * WS_SEA_STEP).toFixed(2);
}

function wsClassifySea(h) {
    if (h == null || !Number.isFinite(h)) return null;
    return WS_SEA_STATE.find(s => h < s.max);
}

async function wsFetchSeaState(beaches) {
    const cells = new Map();
    beaches.forEach(b => {
        if (b.lat == null || b.lon == null) return;
        const k = wsSeaCellKey(b.lat, b.lon);
        if (!cells.has(k)) cells.set(k, { la: Math.round(b.lat / WS_SEA_STEP) * WS_SEA_STEP, lo: Math.round(b.lon / WS_SEA_STEP) * WS_SEA_STEP });
    });
    const arr = [...cells.entries()];
    if (!arr.length) return new Map();
    const lats = arr.map(([, c]) => c.la.toFixed(2)).join(',');
    const lons = arr.map(([, c]) => c.lo.toFixed(2)).join(',');
    const url = `/api/open-meteo-marine.php?latitude=${encodeURIComponent(lats)}&longitude=${encodeURIComponent(lons)}`;
    const res = await fetch(url, { cache: 'no-store' });
    const data = await res.json();
    const list = Array.isArray(data) ? data : [data];
    const out = new Map();
    arr.forEach(([key], i) => { const wh = list[i] && list[i].current ? list[i].current.wave_height : null; if (wh != null) out.set(key, wh); });
    return out;
}

function wsSeaForBeach(b, cellMap) {
    let wh = cellMap.get(wsSeaCellKey(b.lat, b.lon));
    if (wh == null && cellMap.size) { // fallback: cella più vicina
        let bd = Infinity;
        cellMap.forEach((v, k) => {
            const p = k.split(',').map(Number);
            const dd = (p[0] - b.lat) ** 2 + (p[1] - b.lon) ** 2;
            if (dd < bd) { bd = dd; wh = v; }
        });
    }
    return wh;
}

// Popup (port ESATTO v1:1056-1059).
function bathingPopup(b, col, sea, wh, season) {
    const seaLine = sea
        ? `<div><dt>Mare</dt><dd style="color:${sea.color};font-weight:800">${sea.label} (${wh.toFixed(1)} m)</dd></div>`
        : '';
    const seaSrc = sea ? ' · Mare: Open-Meteo Marine' : '';
    return `<article class="ws-temp-variation-popup"><span>Balneazione · EEA</span><h3>${b.name || 'Spiaggia'}</h3>
        <strong style="color:${col}">${WS_BW_LABEL[b.quality] || b.quality}</strong>
        <dl><div><dt>Tipo</dt><dd>${b.category === 'Coastal' ? 'costiera' : (b.category || 'n.d.')}</dd></div>${seaLine}</dl>
        <small>Qualità: classificazione ufficiale stagione ${season} · Fonte: European Environment Agency${seaSrc}</small></article>`;
}

function ensureBathingLayer() {
    const map = state.map;
    if (map.getSource(srcId('bathing'))) return true;
    if (!styleReady('bathing', () => { loadBathing().catch(() => {}); })) return false;
    map.addSource(srcId('bathing'), { type: 'geojson', data: EMPTY });
    // v1: wsBathingPane z630, sopra i marker stazione → niente beforeId.
    // v1 circleMarker: radius 5, fill qualità .92, anello = stato mare
    // (weight 2 se noto, altrimenti bianco 0.8).
    map.addLayer({
        id: srcId('bathing'), type: 'circle', source: srcId('bathing'),
        paint: {
            'circle-radius': 5,
            'circle-color': ['get', 'fill'],
            'circle-opacity': 0.92,
            'circle-stroke-color': ['get', 'stroke'],
            'circle-stroke-width': ['get', 'sw'],
        },
    });
    wireInteractions('bathing', srcId('bathing'), { shellClass: 'ws-temp-variation-popup-shell' });
    return true;
}

async function loadBathing() {
    const seq = ++state.seq.bathing;
    const r = await fetch(BATHING_URL + '?_=' + Math.floor(Date.now() / 86400000));
    const d = await r.json();
    const beaches = d.beaches || [];
    const seaMap = await wsFetchSeaState(beaches).catch(() => new Map());
    if (seq !== state.seq.bathing || !state.enabled.bathing) return;
    if (!ensureBathingLayer()) return;
    state.bathingSeason = d.season;
    const features = [];
    beaches.forEach(b => {
        if (b.lat == null || b.lon == null) return;
        const col = WS_BW_COLORS[b.quality] || '#9aa';
        const wh = wsSeaForBeach(b, seaMap);
        const sea = wsClassifySea(wh);
        features.push({
            type: 'Feature',
            geometry: { type: 'Point', coordinates: [b.lon, b.lat] },
            properties: {
                fill: col,
                stroke: sea ? sea.color : '#fff',
                sw: sea ? 2 : 0.8,
                pp: bathingPopup(b, col, sea, wh, d.season),
                mw: 290,
            },
        });
    });
    setData('bathing', features);
}

// ---------------------------------------------------------------------------
// registro layer: load / refresh / clear
// ---------------------------------------------------------------------------

const RISK_LAYERS = {
    alerts:         { load: loadAlerts,         refreshMs: 0,                   sources: ['alerts'] },
    wildfireAlerts: { load: loadWildfireAlerts, refreshMs: WILDFIRE_REFRESH_MS, sources: ['wildfireAlerts'] },
    firms:          { load: loadFirms,          refreshMs: FIRMS_REFRESH_MS,    sources: ['firms'] },
    // Etna: auto-refresh 5' — durante un'eruzione live pennacchio/tier/slider devono
    // aggiornarsi nel browser aperto (il cron rigenera i dati ogni 20', bust 2').
    etna:           { load: loadEtna,           refreshMs: 5 * 60 * 1000,       sources: ['etna', 'etnaPlume'] },
    waterResources: { load: loadWaterResources, refreshMs: 0,                   sources: ['waterResources'] },
    rivers:         { load: loadRivers,         refreshMs: 0,                   sources: ['rivers'] },
    bathing:        { load: loadBathing,        refreshMs: 0,                   sources: ['bathing'] },
};

const RISK_ERROR_STATUS = {
    alerts: '<strong>Allerte non disponibili.</strong> La mappa resta operativa, riprova piu tardi.',
    wildfireAlerts: '<strong>Allerte incendi DRPC non disponibili.</strong> Riprova piu tardi.',
    firms: '<strong>Incendi non disponibili.</strong> Configura la MAP_KEY o riprova piu tardi.',
};

// ---------------------------------------------------------------------------
// API pubblica
// ---------------------------------------------------------------------------

export function initRiskLayers(map, { beforeId } = {}) {
    state.map = map;
    state.beforeId = beforeId;
}

export function setRiskEnabled(key, on) {
    const cfg = RISK_LAYERS[key];
    if (!cfg || !state.map) return;
    on = !!on;
    if (on === state.enabled[key]) return;
    state.enabled[key] = on;
    if (on) {
        cfg.load().catch(err => {
            console.warn(`[wsv2] risk '${key}': fetch fallita`, err);
            if (RISK_ERROR_STATUS[key]) emitStatus(RISK_ERROR_STATUS[key]);
        });
        // auto-refresh con guard document.hidden (intervalli v1)
        if (cfg.refreshMs > 0) {
            if (state.timers[key]) clearInterval(state.timers[key]);
            state.timers[key] = setInterval(() => {
                if (!document.hidden && state.enabled[key]) cfg.load().catch(() => {});
            }, cfg.refreshMs);
        }
    } else {
        state.seq[key]++;  // invalida fetch in volo
        if (state.timers[key]) {
            clearInterval(state.timers[key]);
            state.timers[key] = null;
        }
        cfg.sources.forEach(s => setData(s, []));
        if (key === 'etna') removeEtnaSlider();
        if (key === 'alerts') state.alertsData = null;
        if (hoverPopup) hoverPopup.remove();
        if (clickPopup) { clickPopup.remove(); clickPopup = null; }
        emitStatus('');
    }
}
